var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.26883 10.7399C3.13826 8.78756 5.8907 4 12.0002 4C18.1098 4 20.862 8.78782 21.7312 10.7401C22.0896 11.5448 22.0896 12.4552 21.7312 13.2599C20.862 15.2122 18.1098 20 12.0002 20C5.8907 20 3.13826 15.2124 2.26883 13.2601C1.91039 12.4552 1.91039 11.5448 2.26883 10.7399ZM11.9999 16C14.2093 16 16.0003 14.2091 16.0003 12C16.0003 9.79086 14.2093 8 11.9999 8C9.79048 8 7.99941 9.79086 7.99941 12C7.99941 14.2091 9.79048 16 11.9999 16Z",
    fill: "#6B92FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12C11.3284 12 12 11.3284 12 10.5C12 10.3253 11.9701 10.1577 11.9153 10.0018C11.9434 10.0006 11.9716 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 11.9716 10.0006 11.9434 10.0018 11.9153C10.1577 11.9701 10.3253 12 10.5 12Z",
    fill: "#6B92FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeFilled);
export default __webpack_public_path__ + "static/media/eyeFilled.14ec8199.svg";
export { ForwardRef as ReactComponent };